


















































































































import { Component } from 'vue-property-decorator';
import cr from "@/CompositionRoot";
import _ from "lodash";
import SelectSpeaker from "@/components/dashboard/SelectSpeaker.vue";
import { EsText, Track } from 'frontend-common';
import ColorPallete from "@/components/dashboard/common/ColorPallete.vue";
import CommonMixin from "@/utils/CommonMixin";
import TextEditor from "@/components/dashboard/common/TextEditor.vue";
import VSwatches from "vue-swatches";

@Component({
    components: {
        TextEditor,
        SelectSpeaker,
        ColorPallete,
        VSwatches
    }
}) export default class extends CommonMixin {

    private progress = false
    private trackDraft = new Track(EsText.createEmpty())
    private dragIndex = -1

    created() {
        this.onReset()
    }

    mounted() {
        this.bindShortcuts()
        this.addOnEscapeListener(() => this.goBack())
        this.addOnSaveListener(() => this.onSubmit())
    }

    get uuid(): string {
        return this.$route.params.uuid
    }

    get trackId(): number {
        return +this.$route.params.trackId
    }

    get track(): Track | undefined {
        return cr.myEventsModule.trackByEventAndId(this.uuid, this.trackId)
    }

    get hasChanges(): boolean {
        return !_.isEqual(this.trackDraft, this.track)
    }

    onDeleteClicked() {
        this.disableShortcuts()
        this.$bvModal.msgBoxConfirm(this.$t("dashboard.track.delete.confirm") as string, {
            title: this.$t("dashboard.track.delete.title") as string,
            okVariant: "outline-danger",
            okTitle: this.$t("dashboard.common.delete") as string,
            cancelVariant: "outline",
            cancelTitle: this.$t("dashboard.common.cancel") as string,
            centered: true,
        }).then(result => {
            this.enableShortcuts()
            if (result) {
                cr.myEventsService.deleteTrack(this.uuid, this.trackId)
                    .then(value => this.$router.push(this.toTracks(this.uuid)))
                    .catch(reason => this.showError(reason))
            }
        })
    }

    onSubmit(onSuccess: Function | null = null) {
        if (this.hasChanges) {
            this.progress = true
            cr.myEventsService.updateTrack(this.uuid, this.trackDraft)
                .then(value => {
                    this.progress = false
                    this.onReset()
                    if (onSuccess) {
                        onSuccess()
                    }
                })
                .catch(reason => {
                    this.progress = false
                    this.showError(reason)
                })
        }
    }

    onReset() {
        this.trackDraft = _.cloneDeep(this.track)!
    }

    goBack() {
        this.$router.push(this.toTracks(this.uuid))
    }

    get isColorSet(): boolean {
        return !_.isEmpty(this.trackDraft.color)
    }

    clearColor(): void {
        this.trackDraft.color = ""
    }

    beforeRouteLeave(to: Location, from: Location, next: Function) {
        if (!this.hasChanges) {
            next()
            return
        }
        this.disableShortcuts()
        this.confirmSave().then(result => {
            this.enableShortcuts()
            if (result != null) {
                result ? this.onSubmit(next) : next()
            }
        })
    }
}
